module.exports = __webpack_public_path__ + "img/my-course-active.1ed73e90.png";